// =======================================
// DATA TYPES
// =======================================

/**
 * Authentication form data structure
 */
export interface AuthFormData {
  email: string;
  password: string;
}

/**
 * Authentication error structure from Supabase
 */
export interface AuthError {
  message: string;
  status?: number;
}

// =======================================
// CONSTANTS AND OPTIONS
// =======================================

/**
 * Form validation constants
 */
export const VALIDATION_RULES = {
  EMAIL: {
    REQUIRED: 'Email is required',
    INVALID: 'Please enter a valid email address'
  },
  PASSWORD: {
    REQUIRED: 'Password is required'
  }
} as const;

/**
 * Authentication-related routes
 */
export const AUTH_ROUTES = {
  LOGIN: '/login',
  PROJECTS: '/projects',
  HOME: '/'
} as const;

/**
 * Default form state
 */
export const DEFAULT_FORM_DATA: AuthFormData = {
  email: '',
  password: ''
} as const; 